var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',{staticClass:"form-panels",attrs:{"accordion":"","multiple":"","readonly":_vm.readonly},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }